import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../comman/footer";
import Header from "../../comman/header";
import { Link } from "react-router-dom";
import CommonMeta from "../../comman/CommonMeta";
import { useTranslation } from "react-i18next";
import disclosures from "../../../helpers/sebiDisclosures.json";

const SebiDisclosures = () => {
  const { t } = useTranslation();

  return (
    <>
      <CommonMeta
        title="Disclosures under Regulation 46 of SEBI (LODR) Regulations - Poddar Pigments Ltd"
        description="Disclosures under Regulation 46 of SEBI (Listing Obligations and Disclosure Requirements) Regulations by Poddar Pigments Ltd"
        keywords="SEBI LODR, Regulation 46, disclosures, poddar pigments, investor relations"
        name="SEBI Disclosures"
        type="article"
      />
      <Header />
      <div className="breadcrumb-wrapper">
        <Container>
          <Row>
            <Col lg={12}>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/investor-relations">{t("Investor Relations")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("Disclosures under Regulation 46 of SEBI (LODR) Regulations")}
                  </li>
                </ol>
              </nav>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="sebi-disclosures-wrapper">
        <Container>
          <Row>
            <Col lg={12}>
              <h2 className="sebi-disclosures-heading">
                {t("DISCLOSURES UNDER REGULATION 46 OF SEBI (LODR) REGULATIONS")}
              </h2>
              <div className="sebi-disclosures-table">
                {disclosures.map((item, i) => (
                  <>
                    {item.id === 14 && (
                      <div className="sebi-disclosures-row sebi-disclosures-subheading" key="financial-heading">
                        <div className="sebi-disclosures-title">
                          <strong>{t("Financial information including:")}</strong>
                        </div>
                        <div className="sebi-disclosures-link"></div>
                      </div>
                    )}
                    <div className="sebi-disclosures-row" key={`disclosure-${i}`}>
                      <div className="sebi-disclosures-title">
                        {t(item.title)}
                      </div>
                      <div className="sebi-disclosures-link">
                        {item.link ? (
                          <a href={item.link} target="_blank" rel="noopener noreferrer">{t("Click here")}</a>
                        ) : (
                          <span>{t("Not Applicable")}</span>
                        )}
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default SebiDisclosures;
